import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../../actions';

export interface RuntimeMenuState {
  isMenuOpen: boolean;
  isGoToAppHidden: boolean | undefined;
}

const initialState: RuntimeMenuState = {
  isMenuOpen: false,
  isGoToAppHidden: undefined,
};

export const menuSlice = createSlice<RuntimeMenuState, SliceCaseReducers<RuntimeMenuState>>({
  name: '@@eskso/runtime/menu',
  initialState,
  reducers: {
    setMenuState: (state, action: PayloadAction<boolean>) => {
      state.isMenuOpen = action.payload;
    },
    setGoToAppHidden: (state, action: PayloadAction<boolean>) => {
      state.isGoToAppHidden = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: (state) => {
      return {
        isMenuOpen: false,
        isGoToAppHidden: state.isGoToAppHidden,
      };
    },
  },
});

export const menu = menuSlice.reducer;
